import { api } from '@/utils/api';
import { type ICreatePaymentRefundData } from '@/types/ICreatePaymentRefundData';
import { type IPaymentRefundsQuery } from '@/types/IPaymentRefundsQuery';

/**
 * Ручки `[Admin] Payment refund controller`.
 *
 * Форма ответов в Swagger не описана (`responses: default`), поэтому здесь они
 * возвращаются как `unknown` и разбираются type guard'ами из
 * `utils/paymentRefundParsers`. Ответы снимаются в dev/api-capture — после
 * фиксации контракта `unknown` заменяется описанными типами.
 */

/**
 * Создаёт заявку на возврат ДС по платежу.
 * @param payload - тело запроса
 * @returns сырой ответ бэка
 */
export const createPaymentRefundRequest = async (
  payload: ICreatePaymentRefundData
): Promise<unknown> => {
  const { data } = await api.post<unknown>('/admin/payment-refund', payload);
  return data;
};

/**
 * Принимает заявку на возврат ДС.
 * @param refundUuid - UUID заявки
 * @returns сырой ответ бэка
 */
export const acceptPaymentRefundRequest = async (
  refundUuid: string
): Promise<unknown> => {
  const { data } = await api.post<unknown>(
    `/admin/payment-refund/${refundUuid}/accept`
  );
  return data;
};

/**
 * Отклоняет заявку на возврат ДС.
 * @param refundUuid - UUID заявки
 * @returns сырой ответ бэка
 */
export const rejectPaymentRefundRequest = async (
  refundUuid: string
): Promise<unknown> => {
  const { data } = await api.delete<unknown>(
    `/admin/payment-refund/${refundUuid}/reject`
  );
  return data;
};

/**
 * Получает список заявок на возврат ДС.
 * @param query - фильтр, пагинация и сортировка
 * @returns сырой ответ бэка
 */
export const fetchPaymentRefundRequests = async (
  query: IPaymentRefundsQuery
): Promise<unknown> => {
  const { data } = await api.get<unknown>('/admin/payment-refunds', {
    params: query
  });
  return data;
};
